/* RESPONSIBLE TEAM: team-fin-qa */

import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class MonitorEditConversationsReviewDetailsRoute extends Route {
  analytics = {
    section: 'standalone',
    place: 'monitor.edit.conversations.review.details',
  };

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(MonitorEditConversationsReviewDetailsRoute);
